export const SEARCH_REPORT = /* GraphQL */ `
  query SearchReport(
    $committeeId: String
    $committeeIds: [String]
    $reportType: String!
    $searchTerm: String
    $columnFilters: String
    $sortField: String
    $sortDirection: String
    $page: Int
    $pageSize: Int
    $searchAfter: String
    $visibleColumns: String
    $reviewerEmployeeId: String
  ) {
    searchReport(
      committeeId: $committeeId
      committeeIds: $committeeIds
      reportType: $reportType
      searchTerm: $searchTerm
      columnFilters: $columnFilters
      sortField: $sortField
      sortDirection: $sortDirection
      page: $page
      pageSize: $pageSize
      searchAfter: $searchAfter
      visibleColumns: $visibleColumns
      reviewerEmployeeId: $reviewerEmployeeId
    ) {
      rowsAsJsonMaps
      columns {
        key
        label
        width
        type
        filterable
        sortable
        isDate
        isDateTime
        isNested
        default
      }
      filterOptionsAsJsonArr
      lastEvaluatedKey
      totalCount
    }
  }
`;

export const EXPORT_SEARCH_REPORT = /* GraphQL */ `
  mutation ExportSearchReport(
    $committeeIds: [String]!
    $reportType: String!
    $searchTerm: String
    $columnFilters: String
    $sortField: String
    $sortDirection: String
    $datetimeId: String!
    $visibleColumns: String
    $outputColumns: String
    $reviewerEmployeeId: String
  ) {
    exportSearchReport(
      committeeIds: $committeeIds
      reportType: $reportType
      searchTerm: $searchTerm
      columnFilters: $columnFilters
      sortField: $sortField
      sortDirection: $sortDirection
      datetimeId: $datetimeId
      visibleColumns: $visibleColumns
      outputColumns: $outputColumns
      reviewerEmployeeId: $reviewerEmployeeId
    ) {
      status
      details
      error {
        message
      }
    }
  }
`;

export const RESOLVE_SELECTED_IDS = /* GraphQL */ `
  query ResolveSelectedIds(
    $committeeId: String
    $committeeIds: [String]
    $reportType: String!
    $searchTerm: String
    $columnFilters: String
    $sortField: String
    $sortDirection: String
    $visibleColumns: String
    $exclusions: String
    $reviewerEmployeeId: String
  ) {
    resolveSelectedIds(
      committeeId: $committeeId
      committeeIds: $committeeIds
      reportType: $reportType
      searchTerm: $searchTerm
      columnFilters: $columnFilters
      sortField: $sortField
      sortDirection: $sortDirection
      visibleColumns: $visibleColumns
      exclusions: $exclusions
      reviewerEmployeeId: $reviewerEmployeeId
    ) {
      selectedIds
    }
  }
`;
